import { Alert } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

const hasRecipients = (value: unknown) =>
  Array.isArray(value) && value.length > 0;

// Copied recipients share the buyer's tracked brochure link.
export const hasCopyRecipients = (cc: unknown, bcc: unknown): boolean =>
  hasRecipients(cc) || hasRecipients(bcc);

export const CopyRecipientsTrackingHint: React.FC<{ show: boolean }> = ({
  show,
}) => {
  const { t } = useLocale();

  if (!show) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      {t(
        'Brochure opens by Cc and Bcc recipients also count as views for the buyer.',
      )}
    </Alert>
  );
};
